import { render, staticRenderFns } from "./formEditEdition.vue?vue&type=template&id=1ed2b554"
import script from "./formEditEdition.vue?vue&type=script&lang=js"
export * from "./formEditEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed2b554')) {
      api.createRecord('1ed2b554', component.options)
    } else {
      api.reload('1ed2b554', component.options)
    }
    module.hot.accept("./formEditEdition.vue?vue&type=template&id=1ed2b554", function () {
      api.rerender('1ed2b554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reverse/edition/components/form/formEditEdition.vue"
export default component.exports